const containsAnyParamInUrl = (url: string, params: string[]) => {
  return params.some((param) => url.toLowerCase().includes(param));
};

export const containsAppParamter = (url: string) =>
  containsAnyParamInUrl(url, ["#iphone", "#android"]);

export const isDarkFromApp = (url: string) =>
  containsAnyParamInUrl(url, ["#iphonedark", "#androiddark"]);
